import { Children } from 'react';
import { hasFeature } from './helpers';

interface FeatureProps {
  feature: string;
  children: JSX.Element;
}

const FeatureToggleHOC = (props: FeatureProps) => {
  return hasFeature(props.feature) ? Children.only(props.children) : null;
};

export default FeatureToggleHOC;
